/* eslint-disable */

import { withAlpha } from '../utils/color.mjs';

/** Onboarding mode from VUE_APP_EASY_EVENT_SELECT: 'force' | 'false', everything else (incl. true, empty) is 'auto'. */
function easyEventSelectMode(value) {
    const normalized = String(value == null ? '' : value).trim().toLowerCase();
    if (normalized === 'force') {
        return 'force';
    }
    if (normalized === 'false' || normalized === '0') {
        return 'false';
    }
    return 'auto';
}

export default {
    DEBUG: false,
    APP_IDENTIFIER: process.env.VUE_APP_APP_IDENTIFIER,
    CUSTOM_BASE: `/img/custom/${process.env.VUE_APP_APP_CUSTOM_ID}`,
    BASE_URL: process.env.VUE_APP_BASE_URL,
    IMAGE_BASE_URL: process.env.VUE_APP_IMAGE_BASE_URL,
    GAMETYPE_LBG: 1,
    GAMETYPE_QUIZ: 2,
    APP_PLATFORM: 'web',
    APP_VERSION: process.env.VUE_APP_VERSION,
    URL: '',
    EMAIL: '',
    REQUEST_TIMEOUT: 0, //no limit
    SOLVE_REQUEST_TIMEOUT: 30000, // solve only: a stalled request ends in the connection error path instead of hanging

    DISABLE_EVENT_SORT_BY_DISTANCE: process.env.VUE_APP_DISABLE_EVENT_SORT_DISTANCE,
    //privacy version
    VUE_APP_PRIVACY_VERSION: process.env.VUE_APP_PRIVACY_VERSION,

    /** Feature settings */
    FEATURE_IFRAME: {
        title: process.env.VUE_APP_IFRAME_TITLE,
        icon: process.env.VUE_APP_IFRAME_ICON,
        url: process.env.VUE_APP_IFRAME_URL,
    },

    FEATURE_GALLERY: {
        title: process.env.VUE_APP_GALLERY_TITLE,
        icon: process.env.VUE_APP_GALLERY_ICON,
        url: process.env.VUE_APP_GALLERY_URL,
    },

    FEATURE_EVIDENCE: {
        title: process.env.VUE_APP_EVIDENCE_TITLE,
        icon: process.env.VUE_APP_EVIDENCE_ICON,
        url: process.env.VUE_APP_EVIDENCE_URL,
    },

    FEATURE_DRAWING: {
        title: process.env.VUE_APP_DRAWING_TITLE,
        icon: process.env.VUE_APP_DRAWING_ICON,
        url: process.env.VUE_APP_DRAWING_BG_IMAGE,
    },

    THEME_DEFAULT_COLORS: {
        backgroundColor: process.env.VUE_APP_COLOR_BACKGROUND,
        textColor: process.env.VUE_APP_COLOR_TEXT,
        btnColorPrimary: process.env.VUE_APP_COLOR_BTN_PRIMARY,
        btnSecondary: process.env.VUE_APP_COLOR_BTN_SECONDARY,
        btnTextColor: process.env.VUE_APP_COLOR_BTN_TEXT,
        headerFooterColor: process.env.VUE_APP_COLOR_HEADER_FOOTER,
        footerIconColor: process.env.VUE_APP_COLOR_FOOTER_ICON,
        footerIconSelectedColor: process.env.VUE_APP_COLOR_FOOTER_ICON_SELECTED,
        imageFullscreenBackground: process.env.VUE_APP_COLOR_IMAGE_FULLSCREEN,
    },

    /** Custom white label settings */
    DISABLE_REGISTER: process.env.VUE_APP_DISABLE_REGISTER,
    DISABLE_GUEST_ACCESS: process.env.VUE_APP_DISABLE_GUEST_ACCESS,
    DISABLE_QR_ACCESS: process.env.VUE_APP_DISABLE_QR_ACCESS,
    DISABLE_PIN_ACCESS: process.env.VUE_APP_DISABLE_PIN_ACCESS,
    DISABLE_LOGOUT: process.env.VUE_APP_DISABLE_LOGOUT,
    DISABLE_LOGIN: process.env.VUE_APP_DISABLE_LOGIN,
    DISABLE_PASSWORT_RESET: process.env.VUE_APP_DISABLE_PASSWORT_RESET,

    /** Onboarding / event selection (docs/build-und-deploy.md, flag catalogue) */
    EASY_EVENT_SELECT: easyEventSelectMode(process.env.VUE_APP_EASY_EVENT_SELECT),
    EASY_EVENT_MODE_AUTO: 'auto',
    EASY_EVENT_MODE_FORCE: 'force',
    EASY_EVENT_MODE_DISABLED: 'false',
    EASY_EVENT_FORCE_EVENT_LIST: process.env.VUE_APP_EASY_EVENT_FORCE_EVENT_LIST,
    EASY_EVENT_HIDE_MAIN: process.env.VUE_APP_EASY_EVENT_HIDE_MAIN,
    EASY_EVENT_HIDE_SCAN: process.env.VUE_APP_EASY_EVENT_HIDE_SCAN,
    SORT_EVENT_LIST_BY_DISTANCE: process.env.VUE_APP_SORT_EVENT_LIST_BY_DISTANCE,
    HIDE_MAIN_EVENT: process.env.VUE_APP_HIDE_MAIN_EVENT,
    EVENTLIST_HIDE_INACTIVE: process.env.VUE_APP_EVENTLIST_HIDE_INACTIVE,
    EVENTLIST_AUTO_CHECKIN_SINGLE: process.env.VUE_APP_EVENTLIST_AUTO_CHECKIN_SINGLE,
    EVENTLIST_QUIZ_EVENTS: process.env.VUE_APP_EVENTLIST_QUIZ_EVENTS,

    DISABLE_TASK_REFRESH_BTN: process.env.VUE_APP_DISABLE_TASK_REFRESH_BTN,
    DISABLE_TASK_SORT_BTN: process.env.VUE_APP_DISABLE_TASK_SORT_BTN,
    DISABLE_TASK_TILE_BTN: process.env.VUE_APP_DISABLE_TASK_TILE_BTN,
    HIDE_TASK_POINTS: process.env.VUE_APP_HIDE_TASK_POINTS,

    ENABLE_TASK_CAMERA_CHOICE: process.env.VUE_APP_ENABLE_TASK_CAMERA_CHOICE,

    /** Always show the "Demo Mode" stamp, like the native debug mode (docs/build-und-deploy.md, flag catalogue) */
    FORCE_DEMO_STAMP: process.env.VUE_APP_FORCE_DEMO_STAMP,

    PRIVACY_URL: process.env.VUE_APP_PRIVACY_URL,
    TERMS_URL: process.env.VUE_APP_TERMS_URL,

    /** Url params **/
    PARAM_NAME_GAMETYPE_ID: 'gametype',
    PARAM_NAME_EVENT_ID: 'eventId',
    PARAM_NAME_WP_ID: 'waypointId',
    PARAM_NAME_HINT_ID: 'hintId',
    PARAM_NAME_APP_ID: 'appId',
    PARAM_NAME_TOKEN: 'token',
    PARAM_NAME_APP_VERSION: 'appVersion',
    PARAM_NAME_LANGUAGE: 'lang',
    PARAM_NAME_PLATFORM: 'platform',
    PARAM_THROW_ERROR: 'throwError',

    /** Event states **/
    STATUS_CREATING: 1,
    STATUS_TESTING: 2,
    STATUS_LIVE: 3,
    STATUS_FINISHED: 4,

    /** Checkin types **/
    CHECKIN_GPS: 0,
    CHECKIN_FREE: 1,
    CHECKIN_QR: 2,
    CHECKIN_IBEACON: 3,
    CHECKIN_AR: 4,
    CHECKIN_PASSWORD: 5,
    CHECKIN_RADIUS_MIN: 10, // means 10m
    CHECKIN_RADIUS_DEFAULT: 30, // means 30m
    DEFAULT_POINTS: 0,

    /** Spot types */
    SPOT_IMG_TYPE_SECRET: '20', //Secret spot icon

    /** Solution types **/
    SOLUTION_TYPE_DEFAULT_ID: 1,
    SOLUTION_TYPE_TEXT_ID: 0,
    SOLUTION_TYPE_MC_ID: 1,
    SOLUTION_TYPE_FOTO_ID: 2,
    SOLUTION_TYPE_QR_ID: 3,
    SOLUTION_TYPE_OPEN_ID: 4,
    SOLUTION_TYPE_VIDEO_ID: 5,
    SOLUTION_TYPE_OPEN_MC_ID: 6,
    SOLUTION_TYPE_VOTING_ID: 7,
    SOLUTION_TYPE_AR_ID: 8,
    SOLUTION_TYPE_JS_TASK_ID: 9,

    /** Spot state */
    SPOT_STATE_ACTIVE: 1,
    SPOT_STATE_INACTIVE: 2,
    SPOT_STATE_SOLVED: 3,
    SPOT_STATE_FAILED: 4,

    /** Answer Results */
    USER_ANSWER_RESULT_FAILED: 1,
    USER_ANSWER_RESULT_TRY_AGAIN: 2,
    USER_ANSWER_RESULT_SOLVED: 3,
    USER_INFO_SPOT_PASSED: 4,

    /** Severity */
    SEVERITY_SUPER_EASY: 1,
    SEVERITY_EASY: 2,
    SEVERITY_MEDIUM: 3,
    SEVERITY_HARD: 4,
    SEVERITY_HARDCORE: 5,

    /** Voting type **/
    VOTING_TYPE_MC: 1,
    VOTING_TYPE_STARS: 2,
    VOTING_TYPE_SMILEYS: 3,
    VOTING_TYPE_THUMBS: 4,
    VOTING_TYPE_OPEN: 5,
    VOTING_TYPE_SMILEYS_BAD: -1,
    VOTING_TYPE_SMILEYS_NEUTRAL: -0,
    VOTING_TYPE_SMILEYS_GOOD: 1,
    VOTING_TYPE_THUMBS_BAD: -1,
    VOTING_TYPE_THUMBS_GOOD: 1,
    //VOTING_TYPE_STARS_COUNT : 5,

    /** Routing types */
    ROUTING_TYPE_SINGLE: 1,
    ROUTING_TYPE_MULTI: 2,
    ROUTING_TYPE_ROUTE: 3,
    ROUTING_TYPE_BUZZER: 4,
    ROUTING_TYPE_MILESTONE: 5,
    ROUTING_TYPE_HIDDENROUTE: 6,

    /** Task view stepper */
    TASK_STEPPER_CHECKIN: 1,
    TASK_STEPPER_TASK: 2,
    TASK_STEPPER_AAC: 3,

    // TODO move to env
    TASK_DEFAULT_IMAGE: process.env.VUE_APP_TASK_DEFAULT_IMG,

    SPOT_LIST_MODE_LIST: 0,
    SPOT_LIST_MODE_TILE: 1,

    // Geolocation tracking state (store module geolocation)
    GPS_STATUS_INACTIVE: 'inactive',
    GPS_STATUS_PENDING: 'pending',
    GPS_STATUS_ACTIVE: 'active',
    GPS_STATUS_DENIED: 'denied',
    GPS_STATUS_UNAVAILABLE: 'unavailable',
    // accuracy (m) above which a fix counts as coarse, and how long (ms) that must persist before the hint
    GPS_COARSE_ACCURACY_M: 1000,
    GPS_COARSE_CONFIRM_MS: 30000,

    // Event Bus
    EVENT_BUS_OPEN_SPOT:'openSpotInOverlay',
    EVENT_BUS_CLOSE_SPOT:'closeSpotInOverlay',
    EVENT_BUS_OPEN_CHECKIN_ACTION:'openCheckinAction',
    EVENT_BUS_CHECKIN_OPEN_SPOT:'checkinOpenSpot',
    EVENT_BUS_REFRESH_SPOT:'refreshSpot',
    EVENT_BUS_NOTIFICATION_SHOW:'notify',
    EVENT_BUS_NOTIFICATION_HIDE:'hide',
    EVENT_BUS_UPDATE_SPOT_ON_MAP:'updateSpotOnMap',

    /** Colors */
    getBlack(opacity = 1) {
        return withAlpha(process.env.VUE_APP_COLOR_TEXT, opacity);
    },
    getGreen(opacity = 1) {
        return withAlpha(process.env.VUE_APP_COLOR_BTN_PRIMARY, opacity);
    },
    getRed(opacity = 1) {
        return withAlpha(process.env.VUE_APP_COLOR_BTN_SECONDARY, opacity);
    },
};
